import { render, staticRenderFns } from "./InwardTransfers.vue?vue&type=template&id=21fd8d58&"
import script from "./InwardTransfers.vue?vue&type=script&lang=js&"
export * from "./InwardTransfers.vue?vue&type=script&lang=js&"
import style0 from "./InwardTransfers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports